export default (fn, time = 1000) => {
  if (fn()) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    const timer = setInterval(() => {
      if (fn()) {
        clearInterval(timer);
        resolve(true);
      }
    }, time);
  });
};
